import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataUser } from '../interfaces/DataUser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MicrosoftAuthService {
  private apiUrl = (environment as any).microsoftAuthUrl || environment.apiBaseUrl + 'api/auth';

  constructor(private http: HttpClient) {}

  login(): void {
    window.location.href = `${this.apiUrl}/login`;
  }

  /**
   * Verifica si el usuario se autenticó con Microsoft
   * @returns true si existe el identificador de Microsoft en localStorage
   */
  isMicrosoftUser(): boolean {
    return !!localStorage.getItem('identificador');
  }

  /**
   * Cierra la sesión del usuario
   * Si se autenticó con Microsoft, redirige al endpoint de logout de Microsoft
   * Si no, solo limpia el almacenamiento local
   * @returns true si es usuario de Microsoft (antes de limpiar)
   */
  logout(): boolean {
    const isMicrosoft = this.isMicrosoftUser();
    
    // Limpiar almacenamiento
    localStorage.clear();
    sessionStorage.clear();
    
    // Si es usuario de Microsoft, redirigir al endpoint de logout
    if (isMicrosoft && (environment as any).microsoftAuthUrl) {
      window.location.href = `${this.apiUrl}/logout`;
      return true;
    }
    
    return false;
  }

  getMeSession(): Observable<DataUser> {
    const headers = new HttpHeaders().set('skipInterceptor', 'true');
    return this.http.get<DataUser>(`${this.apiUrl}/me`, {
      withCredentials: true,
      headers: headers
    });
  }
}
